export default "__VITE_ASSET__DmKsN9Lr__"